import { render, staticRenderFns } from "./MultiAnswersWithSelect.vue?vue&type=template&id=812704ce&scoped=true&"
import script from "./MultiAnswersWithSelect.vue?vue&type=script&lang=js&"
export * from "./MultiAnswersWithSelect.vue?vue&type=script&lang=js&"
import style0 from "./MultiAnswersWithSelect.vue?vue&type=style&index=0&id=812704ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812704ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VChip,VIcon})
